"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var strip = 3;

exports.styles = function (_a) {
  var colorText = _a.colorText,
      colorBg = _a.colorBg,
      colorPrimary = _a.colorPrimary,
      x12 = _a.x12,
      x3 = _a.x3;
  return {
    tabItem: {
      height: x12,
      display: 'inline-block',
      position: 'relative',
      '&:hover, &$hover': {
        background: colorBg.hover,
        cursor: 'pointer'
      },
      '& a': {
        textDecoration: 'none'
      }
    },
    tabItemBody: {
      paddingTop: x3 + strip,
      paddingBottom: x3 - strip,
      paddingRight: x3,
      paddingLeft: x3
    },
    active: {
      '& $text': {
        color: colorPrimary.normal
      },
      '& $borderBottom': {
        height: strip,
        backgroundColor: colorPrimary.normal,
        position: 'absolute',
        bottom: 0,
        left: '10px',
        right: '10px',
        display: 'block'
      }
    },
    fluidItem: {
      flexGrow: 1,
      flexBasis: 0,
      textAlign: 'center'
    },
    fluidBorder: {
      '& $borderBottom': {
        left: 0,
        right: 0
      }
    },
    borderBottom: {
      display: 'none'
    },
    hover: {},
    text: {
      color: colorText.normal
    }
  };
};